import InCellBookingSlotsService from '@/services/InCellBookingSlotsService';

const initialState = () => ({
  bookingSlots: [],
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, initialState());
    },
    SET_BOOKING_SLOTS(state, bookingSlots) {
      state.bookingSlots = bookingSlots;
    },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    async getBookingSlots({ commit }) {
      const response = await InCellBookingSlotsService.getAllInCellBookingSlots();
      commit('SET_BOOKING_SLOTS', response.data);
    },
  },
};